import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class ServicePack {
  create = async (val: any) => {
    await axios({
      method: "post",
      url: `${API_URL}service-package`,
      data: val,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  edit = async (val: any, code: any) => {
    await axios({
      method: "put",
      url: `${API_URL}service-package/${code}`,
      data: val,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
   delete = async (code: any) => {
    await axios({
      method: "delete",
      url: `${API_URL}service-package/${code}`,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };
  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}service-package/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.service;
  };
  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}service-package`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.service;
  };
  search = async (keyword: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}service-package-search/${keyword}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.services;
  };
}
export default new ServicePack();
